import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsertableHostDirective } from './insertable-host';

@NgModule({
  imports: [CommonModule, InsertableHostDirective],
  exports: [InsertableHostDirective],
})
export class InsertableModule {}
